import React from 'react';
import PropTypes from 'prop-types';

const ProgressBar = props => (
  <div
    id={props.progressBarId}
    className={props.progressBarClassName}
    style={props.style}
  >
    <div
      id={props.progressId}
      className={props.progressClassName}
      style={{
        width: `${(props.step * 100) / props.totalSteps}%`,
      }}
    />
  </div>
);

ProgressBar.defaultProps = {
  progressBarId: '',
  progressId: '',
  progressBarClassName: '',
  progressClassName: '',
  style: {},
};

ProgressBar.propTypes = {
  step: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  style: PropTypes.shape({
    display: PropTypes.string,
  }),
  progressBarId: PropTypes.string,
  progressId: PropTypes.string,
  progressBarClassName: PropTypes.string,
  progressClassName: PropTypes.string,
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src-react/ProgressBar/index.jsx